export default "__VITE_ASSET__pCRRplrp__"